import React, { useContext, useEffect, useState} from 'react';
import { UserSessionContext } from 'src/context/UserSessionContext';
import { useNavigate } from 'react-router-dom';

import Navigation from 'src/layout/Header/components/Navigation/Navigation';
import styles from 'src/layout/Header/Header.module.scss'
import { Box, Button, Container, IconButton, Typography, useTheme } from '@mui/material';
import ContentGuard from '../ContentGuard/ContentGuard';
import * as globalConstants from 'src/constants/index';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useScrollDirection } from 'src/hooks/useScrollDirection';

export const Header: React.FC = () => {

  const { user, setUser, onDesignMockupPage, setOnDesignMockupPage } =
    useContext(UserSessionContext);
  const navigate = useNavigate();
  const scrollDirection = useScrollDirection()
  const [menuDrawerOpen, setMenuDrawerOpen] = useState<boolean>(false);
  const theme = useTheme()

  useEffect(() => {}, [onDesignMockupPage]);
  // console.log(onDesignMockupPage)
  return (
    <>
      {onDesignMockupPage === true ? (
        <button
          className={styles.backButton}
          onClick={() => {
            setOnDesignMockupPage(false);
            navigate('/design');
          }}
        >
          back
        </button>
      ) : (
        <>
          <Container
            sx={{
              display: 'flex',
              justifyContent: 'center',
              position: 'sticky',
              transition: 'top 0.3s ease-out',
              top: scrollDirection === 'down' ? '-10vh' : 0,
              zIndex: theme.zIndex.drawer + 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                alignSelf: 'flex-start',
                padding: '4px 24px',
                margin: '16px 0 0 0',
                width: '90%',
                borderRadius: '2rem',
                boxShadow: menuDrawerOpen ? 'none' : `2px 4px 8px ${theme.palette.primary.light}`,
                background: menuDrawerOpen
                  ? `${theme.palette.background.default}F2`
                  : `${theme.palette.primary.light}F2`,
              }}
            >
              <Button
                sx={{
                  padding: 0,
                }}
                onClick={() => {
                  navigate('/home');
                  setMenuDrawerOpen(false);
                }}
              >
                <Typography
                  variant={'h6'}
                  sx={{
                    // fontWeight: theme.typography.fontWeightBold,
                    letterSpacing: '0.15rem',
                  }}
                >
                  David.io
                </Typography>
              </Button>
              {typeof user?.id !== 'undefined' && (
                <IconButton
                  onClick={() => {
                    setMenuDrawerOpen(!menuDrawerOpen);
                  }}
                >
                  {!menuDrawerOpen ? <MenuIcon /> : <CloseIcon />}
                </IconButton>
              )}
            </Box>
          </Container>
          <Navigation
            menuDrawerOpen={menuDrawerOpen}
            setMenuDrawerOpen={setMenuDrawerOpen}
          />
        </>
      )}
    </>
  );
};

export default Header;
